import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import Header from "components/Header/Header";
import AmbassadorHero from "components/AmbassadorHero/AmbassadorHero";
import HowItWorksSection from "components/HowItWorksSection/HowItWorksSection";
import AmbassadorPrograms from "components/AmbassadorPrograms/AmbassadorPrograms";
import CoursePricing from "components/CoursePricing/CoursePricing";
import ContactUsSection from "components/ContactUsSection/ContactUsSection";
import Footer from "components/Footer/Footer";
import BuyCourseCta from "components/BuyCourseCta/BuyCourseCta";
import { fourStepFlow } from 'data/HowItWorksSteps';
import HeaderPartnerInfo from "components/HeaderPartnerInfo/HeaderPartnerInfo";
import ProgressBar from "components/ProgressBar/ProgressBar";
import MandalaBackground from "components/MandalaBackground/MandalaBackground";

const ProgramsPage = () => {
    const location = useLocation();
    useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

    useEffect(() => {
    const hash = "#course-pricing";
    const element = document.querySelector(hash);
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && window.location.hash === hash) {
          history.replaceState(null, "", window.location.pathname + window.location.search);
        }
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

    return (
        <div className="overlay">
            <MandalaBackground/>
            <Header />
            <AmbassadorHero />
            <HeaderPartnerInfo/>
            <HowItWorksSection steps={fourStepFlow} style={{ padding:'1rem 6rem' }} />
            <ProgressBar progress={65} style={{ marginTop: '5rem' }}/>
            <BuyCourseCta/>
            <AmbassadorPrograms />
            <CoursePricing />    
            <ContactUsSection />
            <Footer />
        </div>
    );
};

export default ProgramsPage;